<template>
  <div>
    <HeroHome />
    <CarouselProducts
      v-if="products"
      :alert="alert"
      :products="products"
      class="ViewHome__carousel"
    />
    <HomeMission
      v-if="mission"
      v-bind="mission"
      :products="products"
      :alert="alert"
      class="ViewHome__mission"
    />
    <HomeOfferings class="ViewHome__offerings"/>
  </div>
</template>

<script>
  import Page from '@/api/pages';

  import HeroHome from './HeroHome';
  import HomeMission from './HomeMission';
  import HomeOfferings from './HomeOfferings';
  import CarouselProducts from './CarouselProducts';

  export default {
    components: {
      HeroHome,
      HomeMission,
      HomeOfferings,
      CarouselProducts,
    },
    data() {
      return {
        mission: undefined,
        products: undefined,
        alert: undefined,
      };
    },
    created() {
      this.fetchData();
    },
    methods: {
      async fetchData() {
        const {
          mission,
          featured_products: products,
          alert,
        } = (await Page.where('slug', 'home').first()).acf;

        this.mission = mission;
        this.products = products;
        this.alert = alert;
      },
    },
  };
</script>

<style
  lang="scss"
  scoped
>
  .ViewHome__carousel {
    padding-top: spacing(base-gamma);
    position: relative;
    z-index: 12;

    @include breakpoint(phablet) {
      display: none;
    }
  }

  .ViewHome__mission {
    position: relative;
    z-index: 12;

    .ViewHome__carousel + & {
      margin-top: spacing(base-gamma) * -2;

      @include breakpoint(phablet) {
        margin-top: 0;
      }
    }
  }
</style>
